import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../storage';
import * as storage from '../storage/image';
import { useCallback } from 'react';

/**
 * @description Image Redux에 대한 Custom Hooks
 */
export default function useImage() {
  /**
   * @description Image Store의 State
   * @type {storage.ImageState}
   */
  const image = useSelector((state: RootState) => state.image);
  const dispatch = useDispatch();
  /**
   * @description 고해상도 Header Icon Image 로드하여 저해상도를 대체
   */
  const onHeaderIcon = useCallback(
    () => dispatch(storage.imageThunk(storage.HEADER_ICON, image.header_icon)),
    [dispatch, image.header_icon],
  );

  /**
   * @description 고해상도 MyKeepin App Bar Image 로드하여 저해상도를 대체
   */
  const onKiasBar = useCallback(
    () => dispatch(storage.imageThunk(storage.KISA_BAR, image.kisa_bar)),
    [dispatch, image.kisa_bar],
  );

  /**
   * @description 고해상도 Server Error Image 로드하여 저해상도를 대체
   */
  const onErrorServer = useCallback(
    () =>
      dispatch(storage.imageThunk(storage.ERROR_SERVER, image.error_server)),
    [dispatch, image.error_server],
  );

  /**
   * @description 고해상도 Client Error Image 로드하여 저해상도를 대체
   */
  const onErrorClient = useCallback(
    () =>
      dispatch(storage.imageThunk(storage.ERROR_CLIENT, image.error_client)),
    [dispatch, image.error_client],
  );

  return {
    image,
    check: storage.check,
    onHeaderIcon,
    onKiasBar,
    onErrorServer,
    onErrorClient,
  };
}
